import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Checkbox } from 'semantic-ui-react';

// Actions
import {
    addSelectedTableRow,
    removeSelectedTableRow
    // @ts-ignore
} from 'services/selectedTableCells/actions';

// Selectors
import {
    makeSelectIsRowSelected,
    makeSelectAreSomeRowsSelected
    // @ts-ignore
} from 'services/selectedTableCells/selectors';

interface IOwnProps {
    rowId: number;
}

interface IStateProps {
    checked?: boolean;
    indeterminate?: boolean;
}

interface IDispatchProps {
    addSelectedTableRow: Function;
    removeSelectedTableRow: Function;
}

export interface IProps extends IOwnProps, IStateProps, IDispatchProps {}

export class SelectedTableCellRowCheckbox extends React.PureComponent<IProps> {
    handleChange = () => {
        const { rowId, checked, indeterminate } = this.props;

        if (checked || indeterminate) {
            this.props.removeSelectedTableRow(rowId);
        } else {
            this.props.addSelectedTableRow(rowId);
        }
    };

    handleClick = (event: React.MouseEvent<HTMLInputElement>) => {
        event.stopPropagation();
    };

    render() {
        const { checked, indeterminate } = this.props;
        return (
            <Checkbox
                onChange={this.handleChange}
                onClick={this.handleClick}
                checked={checked}
                indeterminate={!checked && indeterminate}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    checked: makeSelectIsRowSelected(),
    indeterminate: makeSelectAreSomeRowsSelected()
});

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    {
        addSelectedTableRow,
        removeSelectedTableRow
    }
)(SelectedTableCellRowCheckbox);
